export const SELECTORS = {
	ctr: '.world',
	map: '.world__map',
	btn_ctr: '.world__filter .filter',
	btn: '.world__filter .filter__element',
	labels: '.world__locations',
	label: '.world__location',
};

export const CLASSNAMES = {
	active: 'world__location--active',
};
